var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"kingdom-card",class:{ 'is-compact': _vm.compact },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('open')}}},[_c('div',{staticClass:"kingdom-card__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{ref:"el",staticClass:"kingdom-card__chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }